/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import withForm from 'modules/common/hoc/withForm';

const diff = (o1, o2) => {
  const keys = _.union(_.keys(o1), _.keys(o2));
  return _.filter(keys, key => !_.isEqual(o1[key], o2[key]));
};

const shouldProceed = (h, c) => {
  let x = false;
  _.forOwn(h, (v, k) => {
    if (c.indexOf(k) > -1) x = true;
  });
  return x;
};

class DynamicForm extends Component {
  static propTypes = {
    createReadOnly: PropTypes.func.isRequired,
    createInput: PropTypes.func.isRequired,
    createInputNumber: PropTypes.func.isRequired,
    createInputMask: PropTypes.func.isRequired,
    createDatePicker: PropTypes.func.isRequired,
    createSelect: PropTypes.func.isRequired,
    format: PropTypes.instanceOf(Array).isRequired,
    formData: PropTypes.instanceOf(Object).isRequired,
    setFormData: PropTypes.func.isRequired,
    readOnlyValues: PropTypes.instanceOf(Object).isRequired,
  }

  state = {
    hidden: [],
  }

  componentDidMount() {
    const { setFormData, readOnlyValues } = this.props;
    setFormData({
      ...readOnlyValues,
      // account_number: '0000016241',
      // amount: '10',
      // due_date: '2019-04-01',
    });
  }

  componentDidUpdate(props) {
    const { formData: oldForm } = props;
    const { formData: newForm } = this.props;
    if (!_.isEqual(oldForm, newForm)) {
      this.updateHidden(oldForm, newForm);
    }
  }

  updateHidden = (oldForm, newForm) => {
    const changed = diff(oldForm, newForm);
    const { format } = this.props;
    const hiddenData = _.get(format.find(x => x.hidden), 'hidden');
    if (!shouldProceed(hiddenData, changed)) return;
    const { formData } = this.props;
    let toHide = [];
    _.forOwn(hiddenData, (v1, k1) => {
      _.forOwn(v1, (v2, k2) => {
        toHide = toHide.concat([
          {
            path: `${k1}.${k2}`, key: k1, value: k2, hidden: v2,
          },
        ]);
      });
    });
    let hidden = [];
    toHide
      .filter(x => _.get(formData, x.key) === x.value)
      .map((x) => {
        hidden = hidden.concat(x.hidden);
        return null;
      });
    this.setState({ hidden });
  }

  noteByType = ({ type }) => {
    if (type === 'Calendar') return 'MM/DD/YYYY';
    return '';
  }

  isHidden = (row) => {
    const { format } = this.props;
    const hiddenData = _.get(format.find(x => x.hidden), 'hidden');
    if (!hiddenData) return false;
    const condition = hiddenData[row.field];
    if (!condition) return false;
    const { formData } = this.props;
    return _.get(hiddenData, `${row.field}.${formData[row.field]}`);
  }

  renderForm = (row) => {
    // console.log(typeof row, row)
    const {
      createReadOnly,
      createInput,
      createInputNumber,
      createInputMask,
      createDatePicker,
      createSelect,
      readOnlyValues,
    } = this.props;
    const is_required = typeof row.is_required === 'boolean'
      ? row.is_required
      : row.is_required === 'true';
    const form = {
      label: row.label,
      key: row.field,
      note: this.noteByType(row),
    };
    const selectOptions = (row.options || []).map(x => ({ label: x.key, value: x.value }));
    const { hidden } = this.state;
    const isHidden = hidden.indexOf(row.field) > -1;
    if (!row.field || isHidden) return null;

    if (_.has(readOnlyValues, row.field)) {
      return (
        <div className="form-group col-12" key={row.field}>
          { createReadOnly(form) }
        </div>
      );
    }

    const validTypes = [
      'Text',
      'Number',
      'mobilenumber',
      'Dropdown',
      'Calendar',
    ];
    if (validTypes.indexOf(row.type) > -1) {
      return (
        <div className="form-group col-12" key={row.field}>
          {/* <div className="card no-border" key={row.field}> */}
          { row.type === 'Text' && createInput(form, { required: is_required })}
          { row.type === 'Number' && createInputNumber(form, { required: is_required })}
          { row.type === 'mobilenumber' && createInputMask(form, '0\\9999999999', { required: is_required })}
          { row.type === 'Dropdown' && createSelect(form, selectOptions, { required: is_required })}
          {/* { row.type === 'Calendar' && createInputMask(form, '9999-99-99', { required: is_required })} */}
          { row.type === 'Calendar' && createDatePicker(form, { required: is_required })}
        </div>
      );
    }
    console.warn('Unkown type', row.type); // eslint-disable-line
    return (
      <div className="form-group col-12" key={row.field}>
        { createInput(form, { required: is_required }) }
      </div>
    );
  }

  render() {
    const { format } = this.props;
    return (
      <div className="row">
        {/* <div className="card-deck"> */}
        { format.map(this.renderForm)}
      </div>
    );
  }
}

export default withForm(DynamicForm);
